export enum DialogType {
    PathwayUrl = "PathwayUrl"
}
